import type { SpExpLoginData } from "@/api/sp-invite/spInvite.queries";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SpInviteSessionState {
  splashData: SpExpLoginData | null;
  setSplashData: (data: SpExpLoginData | null) => void;
  resetSpInviteSession: () => void;
}

export const useSpInviteSessionStore = create<SpInviteSessionState>()(
  persist(
    (set) => ({
      splashData: null,
      setSplashData: (data) => set({ splashData: data }),
      resetSpInviteSession: () => set({ splashData: null }),
    }),
    {
      name: "sp-invite-session-store",
      partialize: (state) => ({ splashData: state.splashData }),
    },
  ),
);
